const logo: string = 'https://www.freepnglogos.com/uploads/spotify-logo-png/spotify-download-logo-30.png'
export default logo;